var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.075,
    height: 31.075,
    viewBox: "0 0 31.075 31.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-send",
    "data-name": "Icon ionic-ios-send",
    d: "M25.784,4.552,4.775,13.709a.482.482,0,0,0,.017.876l5.683,3.211a.916.916,0,0,0,1.047-.1l11.206-9.66c.074-.063.252-.183.32-.114s-.04.246-.1.32L13.251,19.157a.913.913,0,0,0-.092,1.093l3.714,5.958a.483.483,0,0,0,.87-.011L26.431,5.187A.482.482,0,0,0,25.784,4.552Z",
    transform: "translate(15.537 -6.368) rotate(45)",
    fill: "#686a7d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.aa4f482e2636bf78e7d94640d465259f.svg";
export { ForwardRef as ReactComponent };